import React from 'react';
import LockedDiv from '../../../common/locked-div/LockedDiv';
import Tab from '../../../common/tab';
import withTabAndRealtime from '../common/withTabAndRealtime';
import { indexMapFilter } from '../Const';
import AllExchanges from './AllExchanges';
import { Provider } from '../../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../../common/ComponentNameContext';
import { connect } from 'react-redux';
import { subscribeRealtimeTickTopValue } from './reducer';
import ScrollComponent from './../../../common/ScrollComponent';
import { compose } from 'redux';
import PreRender from '../../../common/PreRender';
import ConstCommon from './../../../common/Const';
import Export from './export/export';
import TabTimer from '../../../common/tab-timer';

const TopValue = props => {
  const { indexTab, changeIndex, typeTab, changeType, id } = props;
  const filter = indexMapFilter[indexTab];

  return (
    <PreRender {...props}>
      <Provider value={id}>
        <ComponentNameProvider value={ConstCommon.listComponent.TopValue}>
          <ScrollComponent>
            <div
              className={`top-nav d-flex flex-column flex-fill ${
                typeTab === 5 ? '' : 'h-100'
              }`}
            >
              <div className={`px-20 pt-8 ${typeTab === 5 ? 'sticky' : ''}`}>
                <Tab
                  currentTab={indexTab}
                  listTab="topVolume.tab"
                  changeTab={changeIndex}
                />
                <div className="w-100">
                  <div className="list-filter top-nav justify-content-between">
                    <TabTimer
                      currentTab={typeTab}
                      listTab="topVolume.tabDataChange.tabDataChangeTab"
                      changeTab={changeType}
                    />
                    {typeTab !== 5 && (
                      <Export typeTab={typeTab} filter={filter} />
                    )}
                  </div>
                </div>
              </div>

              <div className="tab-content d-flex flex-fill flex-column">
                <AllExchanges
                  key={indexTab}
                  typeTab={typeTab}
                  filter={filter}
                />
              </div>
            </div>
          </ScrollComponent>
        </ComponentNameProvider>
      </Provider>
    </PreRender>
  );
};

const mapDispatchToProps = {
  dispatchRealtime: subscribeRealtimeTickTopValue,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
  withTabAndRealtime(ConstCommon.listComponent.TopValue),
)(TopValue);
